// Trust strip directly below the hero. Static, evenly distributed on
// desktop; horizontal scroll on small screens. Claims + icons are the
// official "Skincare Facts" set published on riversol.com.
const CLAIMS = [
  { label: "Dermatologist Developed", icon: "https://www.riversol.com/cdn/shop/files/icon-testing.svg?width=48" },
  { label: "Fragrance-Free", icon: "https://www.riversol.com/cdn/shop/files/icon-fragrance-free.svg?width=48" },
  { label: "Hypoallergenic", icon: "https://www.riversol.com/cdn/shop/files/icon-feather.svg?width=48" },
  { label: "Non-Comedogenic", icon: "https://www.riversol.com/cdn/shop/files/icon-clog.svg?width=48" },
  { label: "Cruelty-Free", icon: "https://www.riversol.com/cdn/shop/files/icon-cruelty-free.svg?width=48" },
  { label: "Made in Canada", icon: "https://www.riversol.com/cdn/shop/files/icon-maple-leaf.svg?width=48" },
];

export const TrustStrip = () => (
  <section className="bg-white border-b border-neutral-200" data-testid="home-trust-strip">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-6 lg:px-12 xl:px-16">
      <ul className="flex items-center gap-8 lg:gap-6 overflow-x-auto lg:overflow-visible lg:justify-between py-5 lg:py-6 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {CLAIMS.map((c, idx) => (
          <li
            key={c.label}
            data-testid={`trust-claim-${idx}`}
            className="shrink-0 flex items-center gap-3 text-neutral-800"
          >
            <img src={c.icon} alt="" className="w-[20px] h-[20px] opacity-80" loading="lazy" />
            <span className="font-mono text-[11px] tracking-[0.18em] uppercase whitespace-nowrap">{c.label}</span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default TrustStrip;
